const eventCode = 251014;

export const EventInfo = {
  eventTitle: "2025 ICode Global Finals",
  subTitle: "World's Largest Coding Competition for kids",
  areaList: [
    { id: 0, name: "All", areaId: null },
    { id: 7, name: "Beijing", areaId: 110000 },
    { id: 1, name: "Shanghai", areaId: 310000 },
    // { id: 2, name: "青岛", areaId: 370200 },
    // { id: 5, name: "南京", areaId: 320100 },
    // { id: 15, name: "海口", areaId: 460100 },
    // { id: 10, name: "兰州", areaId: 620100 },
    // { id: 4, name: "西安", areaId: 610100 },
    // { id: 14, name: "太原", areaId: 140100 },
    // { id: 14, name: "南平", areaId: 350700 }
    
    
    // { id: 16, name: "信阳", areaId: 411500 },
    // { id: 9, name: "贵阳", areaId: 520100 },
    // { id: 8, name: "呼和浩特", areaId: 150100 },
    { id: 17, name: "Dujiangyan", areaId: 510181 },
    { id: 14, name: "HongKong", areaId: 810000 }
    // { id: 18, name: "沈阳", areaId: 210100 },
    // { id: 3, name: "天津", areaId: 120100 },
    // { id: 6, name: "乌鲁木齐", areaId: 650100 },
    // { id: 11, name: "珠海", areaId: 440400 },
    // { id: 12, name: "昆明", areaId: 530100 },
    // { id: 13, name: "长沙", areaId: 430100 }
  ],
  gameList: [
    { gameId: eventCode * 100 + 1, name: "Blockly Junior" },
    { gameId: eventCode * 100 + 2, name: "Blockly Senior" },
    { gameId: eventCode * 100 + 11, name: "Python Primary" },
    { gameId: eventCode * 100 + 12, name: "Python Middle" }
    // { gameId: eventCode * 100 + 13, name: "Python高中组" }
  ]
};
